import React, { useEffect } from "react";
import Billingbanner from "./Billingbanner";
import Billingaboutt from "./Billingaboutt";
import Billingwhy from "./Billingwhy";
import Billingcards from "./Billingcards";
import Billingenquire from "./Billingenquire";
import Billingfeatures from "./Billingfeatures";

const Billingsys = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Billingbanner />

      <Billingaboutt />
      <Billingfeatures/>
      <Billingwhy />
      {/* <Billingenquire/> */}
      <Billingcards/>
    </div>
  );
};

export default Billingsys;
